export default __webpack_public_path__ + "static/avocat-structure-entreprise-avantages-scaled-ffba6aa6fee6a70a8aca075e4c2a49d5.jpg";